/* eslint-disable */ 

// import React, { useState, useContext }  from 'react'
import React, { useState }  from 'react'
// import { Link } from "gatsby"
import { useStaticQuery, graphql } from "gatsby"
// import Tippy from '@tippyjs/react';
// import 'tippy.js/dist/tippy.css'; // optional

// import { Context } from "../Context"

import 'react-tippy/dist/tippy.css';

import { Tooltip } from 'react-tippy';
  


import apiObjectStyles from "./ApiObject.module.css"

export default function ApiMethod({ children, link }) {

    const data = useStaticQuery(graphql`
        query {         
            allApiJson{
                edges {
                  node {
                    name
                    content {
                      title
                      menu_title
                      method
                      version
                      name
                      description
                      message{
                          type
                          text
                      }
                      request_description
                      code_title
                      code {
                        name
                        example
                        example_extended{
                            title
                            request{
                                title
                                code
                            }
                            response{
                                title
                                code
                            }    
                            message                            
                        }
                      }
                      method_arguments{
                        order
                        name
                        data_type
                        short_description
                        required
                        description                          
                      }          
                      return_object{
                          name
                          order
                          description
                          short_description
                      }                                
                      response
                      response_description
                      input_objects{
                          name
                          description
                          short_description                          
                          attributes{
                            name
                            short_description
                            order
                            data_type
                            required
                            description                         
                            attributes{
                                name
                                order
                                required
                                data_type
                                short_description
                                description
                                message{
                                    type
                                    text
                                }                                  
                                attributes{
                                    name
                                    order
                                    required
                                    data_type
                                    short_description
                                    description                                 
                                    attributes{
                                        name
                                        order
                                        required
                                        data_type
                                        short_description
                                        description                                        
                                    }                                         
                                }                                  
                            }                              
                          }
                      }
                      output_objects{
                          name
                          description
                          data_type                       
                          short_description
                          example                           
                          attributes{
                            name
                            order
                            data_type
                            short_description
                            description                                
                            attributes{
                                name
                                order
                                data_type
                                short_description
                                description                                                                     
                            }                               
                          }
                      }                     
                    }
                  }
                }
              }                         
        }
    `)        


   // const [context] = useContext(Context)

    //console.log("context: ", context);

    //const data = context

    // get all data from transcoding api JSON
    // this is same as in Search

    let dataSource = 'transcoding'
    let nodeJSON = data.allApiJson.edges.filter( ({node}) => node.name === dataSource)[0] 
    let contentJSON = nodeJSON.node.content


    const transcodingPrefix = '/api-reference/transcoding/'

    let prefix = null    

    prefix = transcodingPrefix

    let jsonDataArray  = []

    contentJSON.forEach(({ title, description, short_description, name, method, version, method_arguments, return_object, input_objects, output_objects }, sectionIndex) => {

        const http_method = method
        const api_method = `/${version}/${name}`

        jsonDataArray.push({
            id: `transcoding_section_${sectionIndex}`,
            title: title,
            name: name,
            slug: `${transcodingPrefix}#${title.toLowerCase().split(' ').join('-')}`,
            //content: description.replace(/<[^>]+>/g, ''),    
            content: description,
            short_description: short_description,          
            prefix: prefix,
            type: "section",
            http_method: http_method,
            method:api_method,
            var_type:'',
            required:'',
            section: 'Api References'
        })
     

        let methodName = name

        const flattenTree = (data, parent, tableName) => {
            data.forEach(({name, title, data_type, required, attributes, description, short_description}) => {
                
                // we add methodName one time only
                const id = parent ? `${parent}--${name}__${tableName}` : `${methodName}___${name}__${tableName}`                    

                if(attributes){
                    flattenTree(attributes, id, tableName)
                }

                let content = ''
                if(description){
                    //content = description.replace(/<[^>]+>/g, '') 
                    content = description
                }
                
                jsonDataArray.push({
                    id: `${id}`,
                    title: title,
                    name: name,
                    slug: `${transcodingPrefix}#${id}`,
                    content: content,
                    short_description:short_description,
                    prefix: prefix,
                    type: "parameter",
                    http_method: http_method,
                    method:api_method,
                    var_type: data_type,
                    required: required ? "req" : "opt",
                    section: 'Api References'                                      
                })


            })
        }

        if(method_arguments){
            flattenTree(method_arguments, null, 'arguments')
        }  

        if(return_object){
            flattenTree(return_object, null, 'returns')
        }                                

        if(input_objects){
            flattenTree(input_objects, null, 'attributes')
        }

        if(output_objects){
            flattenTree(output_objects, null, 'attributes')
        }                

    })    
    
    // console.log("jsonDataArray: ", jsonDataArray)

    //console.log("link: ", link);
    // /api-reference/transcoding/#start_encode2___query__attributes--format__attributes

    let tooltipData = jsonDataArray.filter(node => node.slug === link)[0];
    //console.log("tooltipData: ", tooltipData);

    // теперь всё понятно, если есть "title": "Creating a Task", - то отсюда, если нет то "name": "create_task", => Create Task

    const [visible, setVisible] = useState(false);
    const show = () => setVisible(true);
    const hide = () => setVisible(false);    

    let tooltipTitle = ''

    if(tooltipData && tooltipData.title){
        tooltipTitle = tooltipData.title
    } else if (tooltipData && tooltipData.name){
        // tooltipTitle = tooltipData.name.replaceAll('_', ' ')
        tooltipTitle = tooltipData.name.replace(/_/g, ' ');
    }

    let tooltipContent = ''

    if(tooltipData && tooltipData.content){
        tooltipContent = tooltipData.content
    } else if (tooltipData && tooltipData.short_description){
        tooltipContent = tooltipData.short_description
    }    

    // find all links that start with # and add prefix
    // add target='_blank'
    if(tooltipContent){
        tooltipContent = tooltipContent.split("href='#").join(`target='_blank' href='${prefix}#`)
        tooltipContent = tooltipContent.split("href=\"#").join(`target='_blank' href=\"${prefix}#`)       
    }


    const TippyContent = (
        <div className={apiObjectStyles.tooltip}>
            {/* <div className={apiObjectStyles.closeBtn} onClick={(hide)} role='button' tabIndex='-1'>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 469.78 469.79">
                    <path d="M285.37,234.69l174-174a35.55,35.55,0,1,0-50.27-50.28l-174,174-174-174A35.55,35.55,0,0,0,10.81,60.7l174,174L10.42,409.09A35.55,35.55,0,1,0,60.7,459.36L235.09,285l174,174a35.55,35.55,0,1,0,50.27-50.27Z"/>
                </svg>                  
            </div> */}
            <div className={apiObjectStyles.header}>
                <div>

                    {
                       tooltipData && tooltipData.name && <div>{tooltipData.name}</div>
                    }
                    

                    {
                        tooltipData && tooltipData.var_type && <div className={apiObjectStyles.type}>{tooltipData.var_type}</div>
                    }

                    
                </div>
                <div>

                    {
                        (tooltipData && tooltipData.required && tooltipData.required === 'opt') && <div className={apiObjectStyles.optional}>optional</div>
                    }

                    {
                        (tooltipData && tooltipData.required && tooltipData.required === 'req') && <div className={apiObjectStyles.required}>required</div>
                    }

                    <div className={apiObjectStyles.method}>api</div>
                </div>
            </div>

            {
                tooltipTitle && <h1 className={apiObjectStyles.title}>{tooltipTitle}</h1>
            }

            {/* {
                tooltipData && tooltipData.title 
                ? <h1 className={apiObjectStyles.title}>{tooltipData.title}</h1>
                : <h1 className={apiObjectStyles.title}>{tooltipData.name.replaceAll('_', ' ')}</h1>
            } */}

            {
                tooltipContent && <div className={apiObjectStyles.content} dangerouslySetInnerHTML={{__html: tooltipContent}}></div>
            }
            
            {/* {
                tooltipData && tooltipData.content 
                    ? <div className={apiObjectStyles.content} dangerouslySetInnerHTML={{__html: tooltipData.content}}></div>
                    : <div className={apiObjectStyles.content} dangerouslySetInnerHTML={{__html: tooltipData.short_description}}></div>
            } */}
            <div className={apiObjectStyles.footer}>
                <a href={link} target='_blank' rel="noreferrer">Show API &gt;</a>
            </div>
        </div>
    )

    if(link){
        return(         

            // <Tippy 
            //     className={apiObjectStyles.tooltip}
            //     interactive={true} 
            //     content={TippyContent} 
            //     visible={visible} 
            //     onClickOutside={hide}
            //     maxWidth={380}
            //     offset={[160, 12]}
            // >
            //     <span data-tooltip="tooltip" onClick={show} className={`${apiObjectStyles.container} ${apiObjectStyles.hasTooltip}`}>            
            //         {children}            
            //     </span>
            // </Tippy>

            <Tooltip
                interactive
                html={TippyContent}         
                arrow={true}
                distance={15}
                offset={150}
                multiple={false}
            >
                <span className={`${apiObjectStyles.container} ${apiObjectStyles.hasTooltip}`}>            
                    {children}            
                </span>            
            </Tooltip>            
        
        )        
    }

    return(         
        <span className={apiObjectStyles.container}>            
            {children}            
        </span>        
    )
}